import React from "react";
import Header from "./Components/Header.jsx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./Components/Footer.jsx";
import Home from "./Pages/Home.jsx";
import ProductDetail from "./Pages/ProductDetail.jsx";
const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:productId" element={<ProductDetail />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
